import axios from "axios";
import config from "../../constants/config";


const url = config.API_URL + "/admin/SignUpCode/";
const url1 = config.API_URL + "/admin/SignUpCodes/";
const url2 = config.API_URL + "/admin/UpdateSignUpCode/";
const url3 = config.API_URL + "/admin/SignUpCodeUsers/";

export const createSignUpCode = async (token, formData) => {
    console.log('called createSignUpCode Method',formData);

    return await axios.post(url, formData, {
        headers: {
            Authorization: token, // Correct placement of Authorization header
            'Content-Type': 'application/json', // Ensure content type is set to JSON
        }
    });
};

export const updateSignUpCode = async (token,signupCodeId, formData) => {
    console.log('called updateSignUpCode Method',signupCodeId,formData);

    return await axios.put(`${url2}${signupCodeId}`, formData, {
        headers: {
            Authorization: token, // Correct placement of Authorization header
            'Content-Type': 'application/json', // Ensure content type is set to JSON
        }
    });
};



export const getSignUpCodes = async (token,search,startDate,endDate,type,statuses,page,limit) => {
    console.log('called getSignUpCodes Method');

    return await axios.get(url1, {
        headers: {
            Authorization: token, // Correct placement of Authorization header
            'Content-Type': 'application/json', // Ensure content type is set to JSON
        },
        params:{
            search: search,
            startDate: startDate ,
            endDate:endDate,
            type:type,
            statuses:statuses,
            page:page,
            limit:limit
          }
    });
};

export const ArchiveSignUpCode = async (token, signupCodeId) => {
    console.log('called ArchiveSignUpCode Method',signupCodeId);

    return await axios.put(`${url2}${signupCodeId}`, {
        status:'ARCHIVED'
    }, {
        headers: {
            Authorization: token, // Correct placement of Authorization header
            'Content-Type': 'application/json', // Ensure content type is set to JSON
        }
    });
};

export const PauseSignUpCode = async (token, signupCodeId) => {
    console.log('called PauseSignUpCode Method',signupCodeId);

    return await axios.put(`${url2}${signupCodeId}`, {
        status:'PAUSED'
    }, {
        headers: {
            Authorization: token, // Correct placement of Authorization header
            'Content-Type': 'application/json', // Ensure content type is set to JSON
        }
    });
};


export const ActivateSignUpCode = async (token, signupCodeId) => {
    console.log('called ActivateSignUpCode Method',signupCodeId);

    return await axios.put(`${url2}${signupCodeId}`, {
        status:'ACTIVE'
    }, {
        headers: {
            Authorization: token, // Correct placement of Authorization header
            'Content-Type': 'application/json', // Ensure content type is set to JSON
        }
    });
};







export const getSignUpUsers = async (token, signupCodeId,tableSearchQuery) => {
    console.log('called getSignUpUsers Method',signupCodeId);

    return await axios.get(`${url3}${signupCodeId}`, {
        params:{
         search:tableSearchQuery
        },
        headers: {
            Authorization: token, // Correct placement of Authorization header
            'Content-Type': 'application/json', // Ensure content type is set to JSON
        }
    });
};
